
const logger = require('../../logger/logger');
var stateManager = require('../../state/stateManager.js');
var guidUtil = require('../../guid/guidUtil.js');
var configurationManager = require('../../config/configurationManager.js');
var shellAPIServer = require('../../api/shellAPIServer.js');
var controlSettingsUtils = require('../../domain/settings/controlSettingsUtils');

var WebSocketClient = require('../../webSocket/webSocketClient.js');

module.exports.creditCardTerminalConfiguration = null;
module.exports.terminalId = null;
module.exports.url = null;
module.exports.webSocketClient = null;

module.exports.UnderlyingDriverName = "";

module.exports.connect = function(creditCardTerminalConfiguration, onConnect, onConnectionError)
{
    var self = this;
    try
    {
        this.creditCardTerminalConfiguration = creditCardTerminalConfiguration;
        var url = `ws://localhost:${configurationManager.getConfig().shellWebSocketServerPort}/SocketHub`;
        this.webSocketClient = new WebSocketClient(url);

        this.webSocketClient.onOpenCallBack = () => 
        {
            self.webSocketClient.onOpenCallBack = null;
            onConnect();
        };

        this.webSocketClient.onErrorCallBack  = (e) =>
        {
            self.close();
            onConnectionError(e);
        };

        this.webSocketClient.connect();
    }
    catch(error)
    {
        self.close();
        onConnectionError(error);
    }
}

module.exports.chargeAmount = (saleId, amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline) =>
{
    if (!this.isConnected())
    {
        logger.warn("Socket is not connected, trying reconnecting", {}, null, module.exports.UnderlyingDriverName);
        this.connect(this.creditCardTerminalConfiguration, ()=>
        {
            logger.info("Reconnecting is successful", {}, module.exports.UnderlyingDriverName);
            this.chargeAmount(saleId, amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
            return;
        }, 
        (error)=>
        {
            logger.warn(`Reconnecting socket failed. ${error}`, {}, error, module.exports.UnderlyingDriverName);
            onError(error);
        } );

        return;
    }

    var reference = guidUtil.generateGuid();
    this.configureWebSocketCallBack(onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
    shellAPIServer.chargeTransaction(reference, amount);
}

module.exports.refundAmount = (amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline) =>
{
    if (!this.isConnected())
    {
        logger.warn("Socket is not connected, trying reconnecting", {}, null, this.UnderlyingDriverName);
        this.connect(this.creditCardTerminalConfiguration, ()=>
        {
            logger.info("Reconnecting is successful", {}, this.UnderlyingDriverName);
            this.refundAmount(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
        }, 
        (error)=>
        {
            logger.warn(`Reconnecting socket failed. ${error}`, {}, error, this.UnderlyingDriverName);
            onError(error);
        } );

        return;
    }

    var reference = guidUtil.generateGuid();

    this.configureWebSocketCallBack(onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
    shellAPIServer.refundTransaction(reference, amount);
}

module.exports.configureWebSocketCallBack = function(onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline)
{
    this.webSocketClient.onMessageCallBack = (response) =>
    {
        if (response.command == "credit.card.transaction.status")
        {
            onStatusMessage(response.statusText);
            return;
        }

        if (response.command == "credit.card.transaction.signature.required")
        {
            response.responseId = "Generic.Response";       //Not used and supplied by Generic Driver.
            if (!controlSettingsUtils.getSignatureCardAllowed())
            {
                this.verifyCardSignature(response.responseId, false);
                return;
            }

            onSignatureVerification(response.responseId, response);
            return;
        }

        if (response.command == "credit.card.transaction.response")
        {
            var creditCardResponse = response.creditCardTransactionResponse
            
            if (creditCardResponse.status == "timeout" || creditCardResponse.status == "error")
            {
                this.webSocketClient.onMessageCallBack = null;
                onError(creditCardResponse.statusText);
                return;
            }

            if (creditCardResponse.status == "approved")
            {
                this.webSocketClient.onMessageCallBack = null;
                onSuccessful(this.convertCreditCardResponseToStandardResponse(creditCardResponse));
                return;
            }

            if (creditCardResponse.status == "declined")
            {
                this.webSocketClient.onMessageCallBack = null;
                onDecline(this.convertCreditCardResponseToStandardResponse(creditCardResponse));
                return;
            }

        }
    }
}

module.exports.verifyCardSignature = (requestId, verified)=>
{
    shellAPIServer.handleSignatureVerificationResponse(requestId, verified);
}

module.exports.convertCreditCardResponseToStandardResponse = function(clientResponse)
{
    clientResponse.cardSchemeName = clientResponse.issuer;
    clientResponse.dateOfExpiry = "N/A";
    clientResponse.primaryAccountNumber = clientResponse.accountNumber;
    clientResponse.cardholderVerificationMethod = clientResponse.authorizationMethod;
    clientResponse.paymentMethod = clientResponse.transactionMode;
    clientResponse.tpi = clientResponse.terminalId;
    clientResponse.transactionTime = clientResponse.authorizationLocalTime;
    clientResponse.transactionDate = clientResponse.authorizationLocalDate;
    clientResponse.transactionId = clientResponse.authorizationReference;
    clientResponse.authCode = clientResponse.authorizationCode;
    clientResponse.amountTotal = clientResponse.transactionAmount;
    clientResponse.driver = this.UnderlyingDriverName;
    return clientResponse;
}

module.exports.close = function()
{
    try
    {
        if (this.isConnected())
        {
            this.webSocketClient.close();
        }

        this.webSocketClient = null;
        var creditCardCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        creditCardCardTerminal.isConnected = false;
    }
    catch(error)
    {
        this.webSocketClient = null;
        logger.warn(`Following error occurred while closing the web socket connection. ${error}`, {}, error, module.exports.UnderlyingDriverName)
    }
}

module.exports.isConnected = function()
{
    return this.webSocketClient != null && this.webSocketClient.isSocketConnected();
}
